import type { ReactNode, HTMLAttributes } from 'react';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export const Card = ({ children, className = '', ...rest }: CardProps) => (
  <div
    className={`rounded-xl border border-[var(--color-line)] bg-[var(--color-surface)] shadow-sm ${
      className
    }`}
    {...rest}
  >
    {children}
  </div>
);

interface CardHeadProps {
  children: ReactNode;
  className?: string;
}

export const CardHead = ({ children, className = '' }: CardHeadProps) => (
  <div className={`border-b border-[var(--color-line)] px-5 py-4 ${className}`}>{children}</div>
);

interface CardBodyProps {
  children: ReactNode;
  className?: string;
}

export const CardBody = ({ children, className = '' }: CardBodyProps) => (
  <div className={`px-5 py-4 ${className}`}>{children}</div>
);
